"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathSegments = void 0;
const disallowedKeys = ["__proto__", "prototype", "constructor"];
exports.getPathSegments = (value) => {
    const segments = Array.isArray(value) ? value : value.split(".");
    return segments.some((segment) => disallowedKeys.includes(segment)) ? [] : segments;
};
//# sourceMappingURL=get-path-segments.js.map